module.exports = __webpack_public_path__ + "static/media/strategicpartnersunselect.3df90c81.png";